<template>
  <div class="premium-container">
    <!-- Overlay de bloqueio -->
    <div class="premium-overlay" v-bind:class="{ 'locked': !isPremium }">
      <!-- Slot para o conteúdo -->
      <div class="premium-content" v-bind:class="{ 'locked-content': !isPremium }">
        <slot name="content"></slot>
      </div>

      <!-- Mensagem de bloqueio -->
      <div class="lock-message" v-if="!isPremium">
        <template v-if="!compactMode">
          <div class="lock-icon">🔒</div>
          <h3>{{ lock.title }}</h3>
          <p>{{ lock.message }}</p>
          <div class="price-tag" v-if="price && price !== '-'">
            <strong>{{ price }}</strong>
          </div>
          <button class="premium-button" @click="onClickAction()">
            🚀 {{ lock.buttonText }}
          </button>
        </template>
        <template v-else>
          <div class="lock-icon">🔒</div>
        </template>
      </div>
    </div>

    <!-- Modal de upgrade -->
    <div class="upgrade-modal" v-bind:class="{ 'active': showModal }">
      <div class="modal-content">
        <button class="close-modal" @click="showModal = false">×</button>

        <div class="lock-icon">👑</div>
        <h2>{{ modal.title }}</h2>
        <p>{{ modal.subtitle }}</p>

        <div class="features-list">
          <li v-for="feature in modal.features">{{ feature }}</li>
        </div>

        <div class="pricing-section" v-if="price">
          <div class="price" v-if="price && price !== '-'">{{ price }}<span>{{ strings[idioma].sufixo_por_mes }}</span>
          </div>
          <p>{{ strings[idioma].modal_cancele_quando_quiser }}</p>
        </div>

        <button class="premium-button" @click="handleUpgrade" style="width: 100%; justify-content: center;">
          💳 {{ modal.buttonText }}
        </button>

        <p class="terms-text">
          {{ strings[idioma].modal_ao_assinar_concorda_termos }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import strings from '../../lang/Strings';
export default {
  name: 'PremiumContent',

  props: {
    compactMode: {
      type: Boolean,
      default: false
    },
    isPremium: {
      type: Boolean,
      default: false
    },
    lockTitle: {
      type: String,
      default: null
    },
    lockMessage: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    modalTitle: {
      type: String,
      default: null
    },
    modalSubtitle: {
      type: String,
      default: null
    },
    upgradeButtonText: {
      type: String,
      default: null
    },
    price: {
      type: String,
      default: '-'
    },
    usesModalDetail: {
      type: Boolean,
      default: false
    },
    features: {
      type: Array,
      default: function () {
        return [
          'Acesso a todo conteúdo premium',
          'Suporte prioritário',
          'Dietas e predições ilimitadas',
          'Cadastro de alimentos',
          'Entre outros...'
        ]
      }
    }
  },

  data: function () {
    return {
      showModal: false
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'strings', 'user']),
    modal() {
      return {
        title: this.modalTitle || this.strings[this.idioma].modal_premium_title || 'Upgrade para Premium',
        subtitle: this.modalSubtitle || this.strings[this.idioma].modal_premium_subtitle || 'Desbloqueie todos os recursos exclusivos',
        buttonText: this.upgradeButtonText || this.strings[this.idioma].premium_conteudo_bloqueado_assinar_agora || 'Assine Agora',
        features: this.idioma === 0 ? [
          'Acesso a todo conteúdo premium',
          'Suporte prioritário',
          'Dietas e predições ilimitadas',
          'Cadastro de alimentos',
          'Entre outros...'
        ] : (this.idioma === 1 ? [
          'Access to all premium content',
          'Priority support',
          'Unlimited diets and predictions',
          'Feed registry',
          'Among others...'
        ] : [
          'Acceso a todo el contenido premium',
          'Apoyo prioritario',
          'Dietas y predicciones ilimitadas',
          'Registro de alimentos',
          'Entre otros...'
        ])
      }
    },
    lock() {
      return {
        title: this.lockTitle || this.strings[this.idioma].premium_conteudo_bloqueado_titulo || 'Conteúdo Pago Bloqueado',
        message: this.lockMessage || this.strings[this.idioma].premium_conteudo_bloqueado_msg || 'Desbloqueie este conteúdo exclusivo fazendo upgrade para um plano pago',
        buttonText: this.buttonText || this.strings[this.idioma].premium_conteudo_bloqueado_fazer_upgrade || 'Fazer Upgrade'
      }
    }
  },

  methods: {
    handleUpgrade: function () {
      window.open('/seja-premium', '_blank');
      this.$emit('upgrade-requested');
      this.showModal = false;
    },
    onClickAction: function () {
      if (this.usesModalDetail) {
        this.showModal = true;
        return;
      }
      this.handleUpgrade();
    }
  }
}
</script>

<style scoped>
.premium-container {
  position: relative;
  width: 100%;
}

/* Overlay de bloqueio */
.premium-overlay {
  position: relative;
}

.premium-overlay.locked::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  z-index: 10;
  border-radius: 12px;
}

.premium-overlay.locked::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  z-index: 11;
  border-radius: 12px;
}

/* Conteúdo bloqueado */
.locked-content {
  filter: blur(8px);
  pointer-events: none;
  user-select: none;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.premium-content {
  transition: all 0.3s ease;
}

/* Mensagem de bloqueio */
.lock-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  z-index: 12;
  width: 80%;
}

.lock-icon {
  font-size: 48px;
  margin-bottom: 20px;
  color: #FFD700;
}

.price-tag {
  background: rgba(255, 255, 255, 0.2);
  padding: 10px 20px;
  border-radius: 25px;
  margin: 15px 0;
  display: inline-block;
}

/* Botão premium */
.premium-button {
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #333;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.premium-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 215, 0, 0.6);
}

.premium-button:active {
  transform: translateY(0);
}

/* Modal de upgrade */
.upgrade-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.upgrade-modal.active {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  background: white;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  max-width: 500px;
  width: 90%;
  transform: scale(0.7);
  transition: transform 0.3s ease;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
}

.upgrade-modal.active .modal-content {
  transform: scale(1);
}

.close-modal {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-modal:hover {
  background: #f5f5f5;
}

.features-list {
  text-align: left;
  margin: 20px 0;
}

.features-list li {
  margin: 10px 0;
  list-style: none;
  padding-left: 25px;
  position: relative;
}

.features-list li:before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #4CAF50;
  font-weight: bold;
}

.pricing-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin: 20px 0;
}

.pricing-section h3 {
  color: #333;
  margin-bottom: 10px;
}

.price {
  font-size: 32px;
  font-weight: bold;
  color: #FFD700;
}

.price span {
  font-size: 14px;
  color: #666;
}

.terms-text {
  margin-top: 15px;
  font-size: 12px;
  color: #666;
}
</style>